import {useCallback, useEffect, useState} from 'react';
import { useDefaultPrices } from 'api/currency/useDefaultPrices';

export default function DefaultPrices () {
  const [defaultPrices, setDefaultPrices] = useState();
  const { getDefaultPrices } = useDefaultPrices();

  const getDefaultTeePrices = useCallback(async () => {
    if (!defaultPrices) {
      const defaultPrices = await getDefaultPrices();
      setDefaultPrices(defaultPrices);
    }
  }, [defaultPrices, getDefaultPrices]);

  useEffect(() => {
    getDefaultTeePrices();
  }, [getDefaultTeePrices]);

  return defaultPrices;
};
